import { styled } from "@mui/material/styles";
import { Button } from "@mui/material";

export const AddEditButton = styled(Button)({
  height: "35px",
  fontSize: "1em",
  textTransform: "none",
  whiteSpace: "nowrap",
  borderRadius: 0,
  opacity: 0.3,
  transition: "opacity 0.5 easeinout",
  "&:hover": {
    opacity: 1,
  },
});
